import React, { useEffect, useState } from 'react';
import { useSearchParams } from "react-router-dom";
import Modal3D from '../../component/custom/3DModal';
import AddToCart from "../../component/custom/AddToCart";
import RefreshStockButton from "./RefreshStockButton";
import ProductCompareSelection from "../ProductCompare/ProductCompareSelection";
import NavigateToProductDetail from "../../component/custom/NavigateToProductDetail";
import DisplayQtyMinQtyMult from "../../component/custom/DisplayQtyMinQtyMult";
import DisplayLifeCycleRisk from "../../component/custom/DisplayLifeCycleRisk";
import noImage from '../../assets/images/noimage.png'
import { Tooltip } from "../../component/Global/Tooltip";
import PriceTable from "../../component/custom/PriceTable";
import AddToBom from "../../component/custom/AddToBom";
import Helper from "../../helper/Helper";
import exportProductListingData, { functionDataOrder } from "./exportProductListingData";
import { useAxiosIndicatorCheck } from "../../store/hook/useAxiosIndicatorCheck";
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';
import { isArray, isNumber, isObject } from "underscore";
import liveAuth from 'src/helper/liveAuth';
import Pagination from "src/component/Global/Pagination"
import { useCartStore } from "../../hooks/cart";
import useReduxState from "../../hooks/useReduxState";
import { useProductStore } from "../../hooks/product";
import System from 'src/helper/system';
import ShowMoreLess from 'src/component/custom/ShowMoreLess';
import $ from "jquery";
import Export from "../../helper/export";
import ProductLegends from './ProductLegends';
import DesignHubModalPopUp from './DesignHubModalPopUp';
import NoResultContent from '../HomePageContent/NoResultContent';
import stickyTableHeader from 'src/helper/stickyTableHeader';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import Constants from 'src/helper/Constants';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import ReusableDiv from 'src/helper/ReusableDiv';
import { useHomePageContentStore } from 'src/hooks/HomePageContent';
import { useProductFilterStore } from 'src/hooks/productFilter';
import QuantityPicker from 'src/component/custom/QuantityPicker';
import swtichattributview from "src/assets/images/switchattributview.svg";
import addtobom from "src/assets/images/addtobom-icon.svg";
import { useBOMStore } from 'src/hooks/bom';
import Bom from "@system/config/bom";
import ProductInventoryDisplay from 'src/component/custom/ProductInventoryDisplay';
import SpecialOffer from 'src/component/custom/SpecialOffer';
import CustomerPartNumberOptions from 'src/component/custom/CustomerPartNumberOptions';
import produceClone from 'src/helper/produceClone';
import ShowAlert from 'src/component/Global/ShowAlert';
import Cookies from 'js-cookie';


const Listing = (props) => {
  const { isBomPLP } = props
  const [searchParams] = useSearchParams();
  const [__check] = useAxiosIndicatorCheck();
  const [firstServerCall, setFirstServerCall] = useState(true);
  const [monitorFunctionCall, setMonitorFunctionCall] = useState({
    monitorJs: false,
    frameWorkReady: false
  });
  const [, setListingAPICallLoader] = useReduxState(false, 'product_listing_listingAPICallLoader');
  const [{ CART_BEFORE_TO_SEND_SERVER }, { get_display_status_button }, { }] = useCartStore();
  const [{ productListWithFacet, category_filter_applied_status, append_facade_options_status, designHubData, compact_expander, model_ProductCompare_data },
    { get_all_design_data, get_product_category_external_search /*, get_product_category_external_heading */, check_designs, get_product_list, get_product_assets }, { }, { optionsAvailable }] = useProductStore();
  const c = System.getParams();
  const bomId = c.bomId
  const bomDetailId = c.bomDetailId
  const [pageLoader, setPageLoader] = useState(false);
  const [designData, setDesignData] = useState();
  const [showDesignHubModal, setShowDesignHubModal] = useState(false);
  const [clickDesignHubId, setClickDesignHubId] = useState(false);
  const [noMessage, setNoMessage] = useState(false);
  const [{ pricing_list }, { get_inventory_by_id, get_inventory_lead_time, get_pricing_by_id, get_current_price_by_quantity }, { }] = useProductInventoryPriceStore();
  const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
  const [firstServerCallFilter, setFirstServerCallFilter] = useReduxState(true, 'setFirstServerCallFilter');
  const [{ filterList, compactView, filterBoxSelection }, { load_product_listing_filterbox_active_selection }, { apply_product_setting, update_product_listing_filterbox_active_selection, apply_product_filter }, { }] = useProductFilterStore();
  const [{ }, { }, { set_individual_tabs_count }] = useHomePageContentStore();
  const { storageName: { PRODUCT_LISTING_VIEW, GUEST_BOM_ID }, avUserInfoData: { speedBoatNameLower } } = System
  const [standardView, setStandardView] = useState(localStorage.getItem(PRODUCT_LISTING_VIEW) !== 'false')
  const list = productListWithFacet
  const { downloadMsg, systemModules: { PLP }, pathNameAmericasCookie } = Constants
  const [{ }, { }, { add_part_to_bom, create_bom, create_params_for_add_part_to_bom }] = useBOMStore();
  const [priceSingleLoader] = useReduxState({}, 'priceSingleLoader')

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [list])

  const [listObj, setListObj] = useState({
    pageCount: 0,
    page: searchParams.get("page") ? parseInt(searchParams.get("page")) : 1,
    limit: searchParams.get("limit") ? parseInt(searchParams.get("limit")) : 20,
    orderby: searchParams.get("orderby") ? searchParams.get("orderby") : '',
    orderbyDirection: searchParams.get("orderbydirection") ? searchParams.get("orderbydirection") : 'asc'
  });

  const fetchDesignData = async (itemNumber) => {
    let design = designHubData?.availableDesigns.find(v => {
      if (v.itemNumber === itemNumber && v.isDesignsAvailable) {
        return v?.designIds
      }
    })
    if (design?.designIds.length > 0) {
      const params = {
        itemNumberArray: design?.designIds
      };
      const results = await get_all_design_data(params);
      if (results && Object.keys(results?.data).length > 0) {
        setDesignData(results?.data);
      }
    }
    setShowDesignHubModal(true)
    setClickDesignHubId(itemNumber)
    System.setEvars('', 'Design Button Click from PDP,PLP')
  };

  useEffect(() => {
    if (__check(['PRODUCT_LISTING_API_CALL']).status && __check(['CART_API_CALL']).status === false) {
      setPageLoader(true)
    } else if (list?.value?.length === 0 && __check(['ALL_CONTENT_COUNT_API_CALL']).status) {
      setPageLoader(true)
    }
    else {
      setPageLoader(false)
    }
  }, [__check(['PRODUCT_LISTING_API_CALL']).status,__check(['ALL_CONTENT_COUNT_API_CALL']).status])

  useEffect(() => {
    setTimeout(() => {
      if (__check(['PRODUCT_LISTING_API_CALL']).status === false &&
        __check(['UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL']).status === false &&
        __check(['CART_API_CALL']).status === false) {
        setNoMessage(false);
      }
      if (pageLoader === false) {
        setNoMessage(true);
      }
    }, 1500)
  }, [pageLoader])

  const getDisplayStatusOfAddToCart = (single_product_pricing_list, single_product, single_product_inventory) => {
    return get_display_status_button(single_product, single_product_pricing_list, single_product_inventory, 'cart')
  };

  useEffect(() => {
    async function fetchHere() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      if (!urlParams.get('go')) {
        const urlPathnameMatch = window.location.pathname;

        const manufactureMatch = "/manufacturers/m/c/";
        const checkManufactureMatch = urlPathnameMatch.indexOf(manufactureMatch);

        const categoryMatch = "/products/c/";
        const categoryMatchSearch = "/products/c/search";
        const checkCategoryMatch = urlPathnameMatch.indexOf(categoryMatch);
        const checkCategoryMatchSearch = urlPathnameMatch.indexOf(categoryMatchSearch);

        if (checkManufactureMatch !== -1) {
          const tempCreateNewUrl = urlPathnameMatch.split("/manufacturers/");

          if (tempCreateNewUrl[1]) {
            const resultUrl = await get_product_category_external_search({ requestUrl: '/manufacturers/' + tempCreateNewUrl[1] });

            if (Helper.valueIsNotNull(resultUrl)) {
              const tempCategoryName = resultUrl?.categoryName;
              const tempCategoryLevel = resultUrl?.categoryLevel;
              const tempManufacturer = resultUrl?.manufacturer;

              if (tempCategoryName && tempCategoryLevel) {
                apply_product_filter({
                  "key": 'ManufacturerName',
                  "main_label": 'Manufacturer',
                  "value": tempManufacturer
                })

                apply_product_filter({
                  "key": "Categories",
                  "main_label": "Category",
                  "value": tempCategoryName,
                  "hidden_payload": { "Level": tempCategoryLevel }
                })
              }
            }
          }
        } else if (checkCategoryMatch !== -1 && checkCategoryMatchSearch === -1) {
          const tempCreateNewUrl = urlPathnameMatch.split("/products/");
          if (tempCreateNewUrl[1]) {
            const resultUrl = await get_product_category_external_search({ requestUrl: '/products/' + tempCreateNewUrl[1] });
            if (Helper.valueIsNotNull(resultUrl)) {
              const tempCategoryName = resultUrl?.categoryName;
              const tempCategoryLevel = resultUrl?.categoryLevel;
              if (tempCategoryName && tempCategoryLevel) {
                apply_product_filter({
                  "key": "Categories",
                  "main_label": "Category",
                  "value": tempCategoryName,
                  "hidden_payload": { "Level": tempCategoryLevel }
                })
              }
            }
          }
        }
      }
      await fetchFromServer()
      setTimeout(() => {
        $(".floating-table").floatingScroll("init");
      }, 2000)
    }

    fetchHere()
  }, [])

  useEffect(() => {
    async function fetchHere() {
      await fetchFromServer()
    }

    if (firstServerCall === false) {
      fetchHere()
    }

  }, [listObj.page, listObj.orderby, listObj.orderbyDirection]);

  useEffect(() => {
    const fetchHere = async () => {
      if (listObj.page === 1) {
        await fetchFromServer()
      } else {
        await defaultPageActive()
      }
    };

    if (firstServerCall === false) {
      fetchHere()
    }
  }, [listObj.limit]);

  const defaultPageActive = async () => {
    setListObj({ ...listObj, page: 1 })
  }

  function preferredOrder(obj, order) {
    let newObject = {};

    for (let i = 0; i < order.length; i++) {
      if (obj.hasOwnProperty(order[i])) {
        newObject[order[i]] = obj[order[i]];
      } else {
        newObject[order[i]] = ""
      }
    }

    const filtered = Object.keys(obj).filter(key => key.includes('Tier')).reduce((ob, key) => {
      ob[key] = obj[key];
      return ob;
    }, {});

    newObject = { ...newObject, ...filtered };
    return newObject;
  }

  const fetchFromServer = async (overWritePage = false) => {
    const p = {
      orderby: listObj.orderby,
      orderbydirection: listObj.orderbyDirection
    };

    let page_here = listObj.page;
    let limit_here = listObj.limit;

    if (overWritePage !== false) {
      page_here = overWritePage;
      setListObj({ ...listObj, limit: limit_here, page: page_here - 1 })
    }

    setPriceLoader(false)
    const res = await get_product_list(parseInt(page_here), parseInt(limit_here), p);
    setPriceLoader(true)
    if (res?.payload && res?.payload?.productCount === 0) {
      setListingAPICallLoader(true)
      setFirstServerCall(false)
    }
    Cookies.set(pathNameAmericasCookie, window.location.href);
  };

  useEffect(() => {
    if (productListWithFacet && productListWithFacet?.productCount) {
      setListObj({ ...listObj, pageCount: Math.ceil(productListWithFacet?.productCount / listObj.limit) });
      set_individual_tabs_count('productListingCount', productListWithFacet?.productCount)
      setListingAPICallLoader(true) // do not set this before list dispatch

      const o = optionsAvailable();
      if ((category_filter_applied_status || append_facade_options_status === 'yes') && o) {
        let res = {}
        Object.entries(o).filter((v, i) => {
          const res1 = update_product_listing_filterbox_active_selection({
            selection: v[1],
            status: true,
          })

          res = { ...res, ...res1 }
        });

        load_product_listing_filterbox_active_selection({ data: res })
      }
    }

  }, [productListWithFacet])

  const refreshStock = async () => {
    setInventoryLoader(true)
    await get_product_assets(list.value, { isPriceCall: false })
    setInventoryLoader(false)
  }

  useEffect(() => {
    let isDisplayFixedHeader = false;
    let refreshStockButton;
    let callback;

    if (list?.value?.length > 0 && !pageLoader) {
      const sort = toggleOrderBy;
      const tableElement = document?.getElementById("my-table");
      let headerHeight = document?.getElementsByClassName("navbar navbar-default white") ? document?.getElementsByClassName("navbar-default")[0]?.clientHeight + 1 : 156;
      const adminToolBarHeight = document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")?.length > 0 ? document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")[0].clientHeight : 0;

      if (adminToolBarHeight > 0) {
        headerHeight = headerHeight + adminToolBarHeight;
      }
      document.addEventListener("scroll", (ScrollEvent) => {
        const tablePosition = tableElement ? tableElement.getBoundingClientRect().y : false;
        const paginationPosition = document?.querySelectorAll("div.pagination-row") ? document?.querySelectorAll("div.pagination-row")?.[0].getBoundingClientRect().y : false;
        if (tablePosition && headerHeight > tablePosition && isNaN(paginationPosition) === false && (Number(headerHeight) + 40 <= Number(paginationPosition)) && !isDisplayFixedHeader) {
          if (!document.getElementById("table_copy")) {
            callback = stickyTableHeader("my-table", headerHeight, "sticky-table-wrapper", 1, sort)
            refreshStockButton = document.getElementsByClassName("refresh-link")
            isDisplayFixedHeader = true;
            refreshStockButton[1].addEventListener("click", refreshStock);
          }
        } else {
          if ((headerHeight < tablePosition || (Number(paginationPosition) <= Number(headerHeight) + 40)) && isDisplayFixedHeader && callback) {
            isDisplayFixedHeader = false;
            if (refreshStockButton && refreshStockButton[1] && refreshStock) {
              refreshStockButton[1]?.removeEventListener("click", refreshStock);
            }
            if (Object.prototype.toString.call(callback) === '[object Function]') {
              callback();
            }
          }
        }
      })

    }
    return () => {
      if (callback) {
        isDisplayFixedHeader = false;
        if (refreshStockButton && refreshStockButton[1] && refreshStock) {
          refreshStockButton[1]?.removeEventListener("click", refreshStock);
        }
        callback();
        window.scrollTo(0, 0)
      }
    }
  }, [list, pageLoader]);

  const [priceLoader, setPriceLoader] = useState(false);
  const [inventoryLoader, setInventoryLoader] = useState(false);

  useEffect(() => {
    async function fetchHere() {

      setInventoryLoader(true);
      setPriceLoader(true);
      setFirstServerCall(false)

      let product = produceClone(list.value);

      if (c.search) {
        const searchedCPN = c.search;

        list.value.forEach((v, i) => {
          if (System.isCPNAvailableInList(v, searchedCPN)) {
            product[i].CPN = searchedCPN;
          }
        });
      }

      await get_product_assets(product);

      setInventoryLoader(false);
      setPriceLoader(false);

      checkDesignsFromServer();
      setTimeout(() => {
        $(".floating-table").floatingScroll("init");
      }, 2000)
    }

    if (list?.value?.length > 0) {
      if (!monitorFunctionCall?.frameWorkReady) {
        System.monitorFrameWorkReady()
        setMonitorFunctionCall({ ...monitorFunctionCall, frameWorkReady: true })
      }
      fetchHere()
    }

  }, [list])

  useEffect(() => {
    if (firstServerCall === false && !monitorFunctionCall?.monitorJs) {
      System.monitorJSDx()
      setMonitorFunctionCall({ ...monitorFunctionCall, monitorJs: true })
    }
  }, [pricing_list])

  const checkIfDesignsAvailable = (itemNumber) => {
    let checkDesign = false
    if (designHubData?.availableDesigns && designHubData?.availableDesigns.find(v => v.itemNumber === itemNumber && v.isDesignsAvailable)) {
      checkDesign = true
    }
    return checkDesign
  };

  const checkDesignsFromServer = async () => {
    if (list?.value && list.value.length > 0) {
      const itemNumbers = [];

      list.value.map((v) => {
        itemNumbers.push(v.ItemNumber)
      });

      await check_designs(itemNumbers);
    }
  };

  const smartlyLoadListingAPICallLoader = (v, idx) => {
    // Prevent loader for universal search
    if (__check(['PRODUCT_LISTING_API_CALL']).status &&
      __check(['UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL', 'CART_API_CALL']).status === false) {
      return true;
    }
    return priceLoader;
  }

  const getStickyclass = () => {
    let stickyClass = 'floating-table product-table  product-table-striped sticky-table-wrapper products-table-wrapper table-responsive position-relative';

    if (model_ProductCompare_data && Object.keys(model_ProductCompare_data).length > 0) {
      stickyClass += ' sticky-scrollbar-compare'
    }
    return stickyClass
  }

  const getOrderByClass = (columnName) => {
    if (columnName === listObj.orderby) {
      return 'sorting sorting_' + listObj.orderbyDirection
    }
    return 'sorting'
  };

  const toggleOrderBy = async (columnName) => {
    setListObj({
      ...listObj,
      orderby: columnName,
      orderbyDirection: (listObj.orderbyDirection === "desc" ? "asc" : "desc")
    });
  };

  const authLoggedIn = () => {
    return liveAuth.check();
  };

  const handlePageClick = async (data) => {
    let here_page = 0

    here_page = data.selected + 1;
    setListObj({ ...listObj, page: here_page })
    Helper.scrollTop();
  };

  const setPageLimit = async (event) => {
    setListObj({ ...listObj, limit: Number(event.target.value) });
  };

  const renderTooltip = (props) => (
    <>
      <RefreshStockButton label={'Refresh Stock'} />
      <br />
      Refresh the product availability to a real time call.
    </>
  );

  const getPriceText = (price, isPrice = false) => {
    if (price && price.quantity && price.quantity > -1 && price.marketPrice &&
      price.marketPrice > -1) {
      if (isPrice) {
        return System.getFormatNumber({ amount: Number(price.marketPrice), isDisplaySymbol: false })
      }
      return System.getFormatNumber({ amount: Number(price.marketPrice), isDisplaySymbol: false });
    }
    return '';
  }

  const exportData = async () => {
    const data = list.value
    if (!data) {
      return;
    }
    const final_Export_Data = [];
    const key_list_to_export = new exportProductListingData()
    await data?.map(async (single_product) => {
      const single_final_product = {};
      Object.entries(key_list_to_export).map((s) => {
        if (single_product[s[0]]) {
          single_final_product[s[1]] = single_product[s[0]];
        }
      });
      if (single_final_product.ERPMFRPartNumber !== '') {
        const price = get_pricing_by_id({
          ItemNumber: single_product.ItemNumber
        });
        let quantity = CART_BEFORE_TO_SEND_SERVER[single_product?.ItemNumber]?.quantityUpdateToCart || "";
        single_final_product.Min = single_product.QtyMin;
        single_final_product.Mult = single_product.QtyMult;
        single_final_product.Quantity = quantity;
        single_final_product['Stock (Availability)'] = get_inventory_by_id(single_product.ItemNumber)?.inventoryQty;
        single_final_product['Lead Time'] = get_inventory_lead_time(single_product?.FactoryLeadTime, single_product?.constrainPartFlag)

        if (single_product.ShortDescription) {
          single_final_product.Description = single_product.ShortDescription
        }
        single_final_product.Currency = window.mct;

        const isCustomerPrice = System.checkIsCustomerPrice(price);

        Helper.rangToArray(1, price.length).map((v) => {
          single_final_product['Tier ' + v + ' - Quantity'] = 'Tier ' + v + ' - Quantity'
          single_final_product['Tier ' + v + ' - Price'] = 'Tier ' + v + ' - Price'

          single_final_product['Tier ' + v + ' - Quantity'] = '';
          single_final_product['Tier ' + v + ' - Price'] = '';

          if (!isCustomerPrice && price[v - 1] && price[v - 1].quantity && price[v - 1].quantity > 0) {
            single_final_product['Tier ' + v + ' - Quantity'] = `${price[v - 1].quantity}+`;
          }
          if (price[v - 1] && price[v - 1].marketPrice > 0) {
            single_final_product['Tier ' + v + ' - Price'] = getPriceText(price[v - 1]);
          }
        });
      }
      single_final_product['Customer Part Number'] = CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber]?.CPN;
      const reordered_single_final_product = preferredOrder(single_final_product, new functionDataOrder())

      final_Export_Data.push(reordered_single_final_product);
    });
    const f = [];

    await Promise.all(Object.entries(final_Export_Data).map((v, key) => {
      if (Object.entries(v[1]).length > 0) {
        Object.keys(v[1]).map((key, i) => {
          if (v[1][key] === '' || v[1][key] === 0 || v[1][key] === null || (isObject(v[1][key]) && Object.entries(v[1][key]).length <= 0) || (isArray(v[1][key]) && v[1][key].length <= 0) || v[1][key] === undefined) {
            v[1][key] = ''
          }
        })
      }
      f.push(v[1]);
    }));
    await exportDataToFile(f);
    showDownloadMessage();
  };

  const exportDataToFile = async (data) => {
    Export.toExcel(data, 'ProductListingExport')
  };

  const detectDynamicFieldIsAttribute = (field) => {
    return System.getFieldType(field) === Constants.CognitiveSearchFieldConfig.attributes;
  };

  useEffect(() => {
    async function fetchHere() {
      if (listObj.page === 1) {
        await fetchFromServer()
      } else {
        setListObj({ ...listObj, page: 1 })
      }
    }

    if (firstServerCall === false && firstServerCallFilter === false) {
      fetchHere()
    }
  }, [filterList])

  const [compact_view_individual, set_compact_view_individual] = useState([]);

  const toggle_compact_view_individual = async (singleProduct) => {
    if (!compact_view_individual.includes(singleProduct.ItemNumber)) {
      set_compact_view_individual((prevValue) => [...prevValue, singleProduct.ItemNumber]);
    } else {
      const arrayWithoutRemovedItem = compact_view_individual.filter((x) => x !== singleProduct.ItemNumber)

      set_compact_view_individual(arrayWithoutRemovedItem)
    }
  };

  // const onEmail = (event) => {
  //   System.popup('SendEmailOfCurrentPage')
  // }

  const showProductPrice = (v) => {
    if (priceSingleLoader[v.ItemNumber]?.status) {
      return ""
    }
    const priceList = get_pricing_by_id({ ItemNumber: v.ItemNumber });
    if (CART_BEFORE_TO_SEND_SERVER[v.ItemNumber] && priceList?.length && CART_BEFORE_TO_SEND_SERVER[v.ItemNumber]?.is_updated_qty) {
      let qty = CART_BEFORE_TO_SEND_SERVER[v.ItemNumber].quantityUpdateToCart;
      let p = Number(parseFloat(get_current_price_by_quantity(priceList, qty, true)?.marketPrice * qty).toFixed(3));

      if ((isNumber(p) && !isNaN(p)) === false) {
        return "";
      }
      return (
        <>
          <div className="price dense-hide mb-2">
            <strong>
              {window.mct} {window.mct !== window.mcs && <span>{window.mcs}</span>}:
            </strong>

            <div className="pull-right font-bold">
              {System.getFormatNumber({ amount: p, maximumFractionDigits: 2, isDisplaySymbol: false })}
            </div>
          </div>

        </>
      );
    } else {
      return "";
    }
  };

  const openAddToBOM = async (e) => {
    if (authLoggedIn()) {
      if (isBomPLP) {
        System.popup('AddedToBomPopup', { single_product: e, bomId, bomDetailId, bomNoMatchType: c.no_match })
      } else {
        let _product = {
          ...e,
          QtyMin: CART_BEFORE_TO_SEND_SERVER[e.ItemNumber]?.quantityUpdateToCart || e.QtyMin
        };
        System.popup('AddToBOMPopup', { single_product: _product, addFrom: PLP })
      }
    } else {
      const guestBomID = localStorage.getItem(GUEST_BOM_ID)
      let params = create_params_for_add_part_to_bom(e)

      if (isBomPLP) {
        System.popup('AddedToBomPopup', { single_product: e, bomId, bomDetailId, bomNoMatchType: c.no_match })
      } else {
        if (guestBomID) {
          const addPart = await add_part_to_bom(params)
          if (addPart?.data) {
            localStorage.setItem("adobeEventType", "addToBOM");
            redirectToBOM(guestBomID);
          }
        } else {
          params.source = Constants.systemModules.PLP
          const newBom = await create_bom(params);
          if (newBom?.data) {
            redirectToBOM(newBom.data);
          }
        }
      }
    }
  };

  const redirectToBOM = (bomId) => {
    window.location.href = Bom.getBomDetailByIdRouteURL(
      bomId,
      {
        go: System.getParams().go
      }
    )
  };

  const getPriceLines = (itemNumber) => {
    if (Object.entries(compact_view_individual).length > 0 && compact_view_individual[itemNumber]) {
      return 100
    }
    return 2
  }

  const showDownloadMessage = () => {
    system_alert_indicator({
      name: 'exportMsgForListing',
      message: downloadMsg,
      type: "success"
    })
  }

  useEffect(() => {
    if (document.getElementsByClassName('snippet') && document.getElementsByClassName('snippet').length > 0) {
      document.getElementsByClassName('snippet')[0].style.display = 'none';
    }
  }, [])
  const viewChange = (view) => {
    setStandardView(view)
    localStorage.setItem(PRODUCT_LISTING_VIEW, view);
  }

  const getTableHeader = () => {
    return (
      <><th>Price</th>
        <th className='minw250'>
          Availability
          <RefreshStockButton fetchInventoryFromServer={async () => { refreshStock() }} label={'Refresh Stock'} />
          <span aria-label="Stock"
            className={'sort-container ' + getOrderByClass('Stock')}
            onClick={async () => {
              await toggleOrderBy('Stock')
            }}
          >
          </span>
        </th>
        <th>Manufacturer
          <span aria-label='ManufacturerName'
            className={'sort-container ' + getOrderByClass('ManufacturerName')}
            onClick={async () => {
              await toggleOrderBy('ManufacturerName');
            }}></span>
        </th>
      </>
    )
  }
  const getTableRow = (v) => {

    return (
      <>
        <td className="price-th">
          <>
            {smartlyLoadListingAPICallLoader(v) === true ?
              <AxiosIndicatorRunTimeLoader /> :
              <div className="price-td bs5 row m-0 flex-nowrap">
                <div className="col ps-0 price-table">
                  <CustomerPartNumberOptions
                    single_product={v}
                  />
                  <PriceTable
                    auto_select_from_cart_data={false}
                    linesToDisplay={!compactView && !compact_view_individual.includes(v.ItemNumber) ? 100 : compact_view_individual.includes(v.ItemNumber) ? 100 : getPriceLines(v.ItemNumber)}
                    compactView={compactView && compact_view_individual.includes(v.ItemNumber)}
                    single_product_inventory={get_inventory_by_id(v.ItemNumber)}
                    single_product={v}
                    single_product_pricing_list={get_pricing_by_id({ ItemNumber: v.ItemNumber })} />
                </div>
                <div className="col-auto p-0 quanitity-add2cart-wrapper">
                  <SpecialOffer single_product={v} single_product_pricing_list={get_pricing_by_id({ ItemNumber: v.ItemNumber })}
                    single_product_inventory={get_inventory_by_id(v.ItemNumber)} />

                  {showProductPrice(v)}
                  <div
                    className="text-start small-text light light-text collapse_minmax">
                    <DisplayQtyMinQtyMult single_product={v} />
                  </div>
                  <div
                    className={compact_view_individual.includes(v.ItemNumber) ? "d-flex condensed-qty-view" : `d-flex ${!getDisplayStatusOfAddToCart(get_pricing_by_id({
                      ItemNumber: v.ItemNumber
                    }), v, get_inventory_by_id(v.ItemNumber)) && 'flex-column'}`}>
                    <div className="quantity clearfix ">
                      <div className="quantity-picker">
                        <div className="bs5 input-group flex-nowrap border-0">
                          <QuantityPicker single_product={v}
                            single_product_inventory={get_inventory_by_id(v.ItemNumber)}
                            single_product_pricing_list={get_pricing_by_id({ ItemNumber: v.ItemNumber })} />
                        </div>
                      </div>
                    </div>
                    {compactView && !compact_view_individual.includes(v.ItemNumber) &&

                      <AddToCart
                        special_class_for_add_to_quote={'bs5 btn btn-secondary'}
                        isBomPLP={isBomPLP}
                        isCompactView={true}
                        single_product_pricing_list={get_pricing_by_id({
                          ItemNumber: v.ItemNumber
                        })}
                        single_product_inventory={get_inventory_by_id(v.ItemNumber)}
                        single_product={v}
                        isOnSamePage={true}
                        isFrom={PLP}
                        isHideClickToQuote={true} />}
                  </div>

                  {!isBomPLP ?
                    <>
                      <AddToCart
                        special_class_for_add_to_quote={'bs5 btn btn-secondary'}
                        isBomPLP={isBomPLP}
                        isCompactView={!!(compactView && !compact_view_individual.includes(v.ItemNumber))}
                        single_product_pricing_list={get_pricing_by_id({
                          ItemNumber: v.ItemNumber
                        })}
                        single_product_inventory={get_inventory_by_id(v.ItemNumber)}
                        single_product={v}
                        isFrom={PLP}
                        isHideAddToCart={!!(compactView && !compact_view_individual.includes(v.ItemNumber))} />
                    </>
                    :
                    <AddToBom
                      isBomPLP={isBomPLP}
                      single_product={v}
                      bomNoMatchType={c.no_match} />}

                </div>
              </div>}
          </>
        </td><td>
          {inventoryLoader ?
            <AxiosIndicatorRunTimeLoader /> : <ProductInventoryDisplay single_product={v} single_product_inventory={get_inventory_by_id(v.ItemNumber)} />}
        </td><td>{v.ManufacturerName ? v.ManufacturerName : ''}</td></>
    )
  }

  return (
    <>
      <div className='mt-2'>
        <ShowAlert onlyShowMessage={['exportMsgForListing']} />
      </div>

      <div className="container-fluid maxw100 container-fluid-plp">
        <>
          <div className="table-area">
            <>
              {list?.value?.length !== 0 &&
                <div className="table-area-actions d-flex flex-wrap">
                  <div className="table-area-actions-left">
                    {isBomPLP &&
                      <div>
                        <a className="me-3 mt-3 d-block"
                          onClick={() => {
                            window.location.href = Bom.getBomDetailByIdRouteURL(bomId)
                          }}><i className="fa fa-angle-double-left" aria-hidden="true"></i> Back to BOMs</a>
                      </div>
                    }
                  </div>
                  <div className="table-area-actions-right ms-auto">
                    <div className="table-area-actions-buttons">
                      <Tooltip
                        opener={() => (
                          <button className="bs5 btn btn-secondary" style={{ cursor: 'auto' }}>
                            <i className="fa fa-info-circle text-darkgreen me-2" aria-hidden="true" />
                            TOOLTIP
                          </button>
                        )}
                        content={() => (
                          renderTooltip()
                        )}
                      />
                      {/* <button style={{ cursor: 'pointer' }} onClick={onEmail} className="bs5 btn btn-secondary">Email </button> */}
                      <button style={{ cursor: 'pointer' }} onClick={exportData} className="bs5 btn btn-secondary">Download </button>

                    </div>
                    <div>
                      {standardView ?
                        <div className='switch-attributed'>
                          <img src={swtichattributview} className="me-2" />
                          <a onClick={() => viewChange(false)} className="">Switch to <b>Attribute View</b> </a>
                        </div>
                        :
                        <div className='switch-attributed'>
                          <img src={swtichattributview} className="me-2" />
                          <a onClick={() => viewChange(true)} className="">Switch to <b>Standard View</b>  </a>
                        </div>
                      }
                    </div>
                    <div className="density-links">
                      <div className="btn-group switchbtns">
                        <Tooltip position={'top right'}
                          opener={() => (
                            <button aria-label="Expand table rows to see more information per line" type="button"
                              onClick={() => {
                                apply_product_setting({
                                  key: 'compact_view',
                                  value: false
                                });

                                set_compact_view_individual([])
                              }}
                              className={compactView ? 'btn btn-primary btn-normal' : 'btn btn-primary btn-normal active'}>
                              <i className="density-expanded-icon btn-normal" />
                            </button>
                          )}
                          content={() => (
                            <>
                              Expand Table Rows, <br />To see more information per line.
                            </>
                          )}
                        />
                        <Tooltip
                          position={'top right'}
                          opener={() => (
                            <button aria-label="Condense table rows to see more results at once" type="button"
                              onClick={() => {
                                apply_product_setting({
                                  key: 'compact_view',
                                  value: true
                                });
                              }}
                              className={compactView ? 'btn btn-primary btn-dense active' : 'btn btn-primary btn-dense'}>
                              <i className="density-condensed-icon" />
                            </button>
                          )}
                          content={() => (
                            <>
                              Condense Table Rows, <br />To see more results at once.
                            </>
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              }
              {pageLoader === false && firstServerCall && noMessage && list?.value?.length === 0 && !c?.search ?
                <>
                  <br />
                  <NoResultContent
                    message={
                      'No Results Found'
                    }
                  />
                </>
                :
                (pageLoader || (list?.value && list.value.length > 0) || (firstServerCall && !pageLoader)) &&
                <div className='position-relative'>
                  <div>
                    {(pageLoader || (firstServerCall && !pageLoader)) && !list?.value?.length >= 0 && <AxiosIndicatorRunTimeLoader overlay={true} />}
                  </div>
                  <div
                    id="sticky-table-wrapper" className={getStickyclass()}>

                    <table className="bs5 table sticky-table table-bordered search-products-table" id="my-table">
                      <thead>
                        <tr>
                          <th>Product
                            <span aria-label="ERPMFRPartNumber"
                              className={'sort-container ' +
                                getOrderByClass('ERPMFRPartNumber')
                              }
                              onClick={async () => {
                                await toggleOrderBy('ERPMFRPartNumber')
                              }}
                            >
                            </span>
                          </th>
                          {standardView &&
                            <>{getTableHeader()}</>
                          }
                          <th aria-label='information'>Information</th>
                          {filterBoxSelection && Object.entries(filterBoxSelection).length > 0 &&
                            Object.entries(filterBoxSelection).map((v) => (
                              <React.Fragment key={Helper.UUID()}>
                                {detectDynamicFieldIsAttribute(v[1].slug) === true &&
                                  <th>{v[1].main_label}</th>
                                }
                              </React.Fragment>
                            ))
                          }
                          {list?.searchFacets?.FamilyName?.FamilyName.length !== 0 &&
                            <th>Product Family
                              <span aria-label="FamilyName"
                                className={'sort-container ' +
                                  getOrderByClass('FamilyName')
                                }
                                onClick={async () => {
                                  await toggleOrderBy('FamilyName')
                                }}
                              >
                              </span>
                            </th>}

                          {!standardView &&
                            <>{getTableHeader()}</>
                          }
                        </tr>
                      </thead>
                      <tbody className="border-top-0">
                        {list?.value && list.value.length &&
                          list.value.map((v, i) => (
                            <React.Fragment key={i}>
                              {showDesignHubModal && clickDesignHubId === v.ItemNumber && (
                                <DesignHubModalPopUp
                                  showDesignHubModal={showDesignHubModal}
                                  setShowDesignHubModal={setShowDesignHubModal}
                                  productDetail={v}
                                  designData={designData}
                                />
                              )}
                              <tr
                                className={compactView ? (compact_view_individual.length > 0 && compact_view_individual.includes(v.ItemNumber) ? 'dense-row' : 'dense dense-row') : ''}>
                                <td className=" product-th additional-stock-wrapper mobile-block product-data">

                                  <div className="col-12 nopadding product-td">
                                    <div className="bs5 row m-0 flex-nowrap">
                                      <div className="col-auto p-0 position-relative">
                                        <div
                                          className={compactView ? (compact_view_individual.length > 0 && compact_view_individual.includes(v.ItemNumber) ? 'product-expander d-block expanded' : 'product-expander d-block') : 'product-expander'}
                                          onClick={() => {
                                            apply_product_setting({
                                              key: 'compact_expander',
                                              value: !compact_expander
                                            });
                                            toggle_compact_view_individual(v)
                                          }}
                                        >
                                          <a href={void (0)} className="text-green">
                                            {compactView && ((compact_view_individual).length === 0 || (compact_view_individual.length > 0 && !compact_view_individual.includes(v.ItemNumber))) ?
                                              <i className="fa fa-angle-double-down" /> :
                                              <i className="fa fa-angle-double-up" />
                                            }
                                          </a>
                                        </div>
                                      </div>
                                      <div className="col-4 product-info nopadding">
                                        <div className="product-img sect-1 text-center">
                                          <NavigateToProductDetail
                                            rel="nofollow"
                                            data={{ ManufacturerName: v?.ManufacturerName, ERPMFRPartNumber: v?.ERPMFRPartNumber, ItemNumber: v?.ItemNumber, ERPPartNumber: v?.ERPPartNumber }}>
                                            <img className="img"
                                              src={v.AssetURL ? v.AssetURL : noImage}
                                              title={v.AssetURL ? v.ERPMFRPartNumber : ""} alt={v.AssetURL ? v.ERPMFRPartNumber : ""} />
                                          </NavigateToProductDetail>
                                        </div>
                                        <div className="sect-2">
                                          <div className="sect-row">
                                            <div className="add-to-bom" onClick={(e) => openAddToBOM(v)}>
                                              <a className="img-text">
                                                <img src={addtobom} alt='BOM' className='bom_img img' />
                                                <span className="blue text">
                                                  Add To BOM
                                                </span>
                                              </a>
                                            </div>
                                            <div className="datasheet">
                                              {v.DatasheetUrl ?
                                                <a className="datasheet-align img-text" aria-label="Datasheet"
                                                  rel="nofollow"
                                                  href={v.DatasheetUrl}
                                                  target="_new">
                                                  <div className="datasheet_img datasheet_img_download img" />
                                                  <span className="blue text">
                                                    Datasheet
                                                  </span>
                                                </a> :
                                                ReusableDiv.dataSheetTooltip()
                                              }
                                            </div>

                                            <DisplayLifeCycleRisk single_product={v} />
                                          </div>

                                          <div className="shipping_address_checkbox">
                                            <ProductCompareSelection single_product={v}
                                              model_ProductCompare_data={model_ProductCompare_data} />
                                          </div>

                                        </div>
                                      </div>
                                      <div className="col-7 static-position product-info-sect-2">
                                        <div>
                                          <div>
                                            <div className="product-name text-blue">
                                              <NavigateToProductDetail
                                                data={{ ManufacturerName: v?.ManufacturerName, ERPMFRPartNumber: v?.ERPMFRPartNumber, ItemNumber: v?.ItemNumber, ERPPartNumber: v?.ERPPartNumber }}>
                                                <strong>{v.ERPMFRPartNumber ? v.ERPMFRPartNumber : ''}</strong>
                                              </NavigateToProductDetail>
                                            </div>
                                            {v.ManufacturerName &&
                                              <a
                                                href={`/${speedBoatNameLower}/manufacturers/m/${Helper.replaceSpecialChar(v.ManufacturerName?.toLowerCase())}/`}
                                                className="text-blue cursor-pointer"
                                              >
                                                {v.ManufacturerName}
                                              </a>
                                            }
                                          </div>

                                          {v.ShortDescription ?
                                            <ShowMoreLess single_product={v} /> : ''}
                                        </div>

                                        <div className="bottom-align dense-hide">

                                          <Modal3D value={v} />

                                          {v.ManufacturerPartNumber &&
                                            <div className='mt-2'><strong>Avnet Manufacturer Part #: </strong>
                                              {v.ManufacturerPartNumber}
                                            </div>
                                          }

                                          {checkIfDesignsAvailable(v?.ItemNumber) && (
                                            <>
                                              <div onClick={() => fetchDesignData(v?.ItemNumber)} className="designhub d-flex align-items-center mt-2">
                                                <div className="designshub_img"></div>
                                                <span className="bs5 text-blue lh-base cursor-pointer">
                                                  Designs
                                                </span>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                {
                                  standardView &&
                                  <>{getTableRow(v)}</>
                                }
                                <td>
                                  <ul
                                    className={compactView ? "list-text plp-info-ledgend d-flex flex-wrap" : "list-text plp-info-ledgend"}>
                                    <ProductLegends
                                      single_product={v}
                                      onlyIcon={!!compactView}
                                      onlyIconTitle={compactView === false} />
                                  </ul>
                                </td>
                                {filterBoxSelection && Object.entries(filterBoxSelection).length > 0 &&
                                  Object.entries(filterBoxSelection).map((v_listing) => (
                                    <React.Fragment key={Helper.UUID()}>
                                      {detectDynamicFieldIsAttribute(v_listing[1].slug) &&
                                        <td>
                                          {v.dynamic_columns && v.dynamic_columns[v_listing[1].slug] &&
                                            <>
                                              {v.dynamic_columns[v_listing[1].slug]}
                                            </>
                                          }
                                        </td>
                                      }
                                    </React.Fragment>
                                  ))
                                }
                                {
                                  list?.searchFacets?.FamilyName?.FamilyName.length !== 0 &&
                                  <td>{v.FamilyName}</td>
                                }
                                {!standardView &&
                                  <>
                                    {getTableRow(v)}</>
                                }
                              </tr>
                            </React.Fragment>
                          ))
                        }
                      </tbody>
                    </table>
                  </div>

                  <div className="pagination-row">
                    <div className="pagination-wrapper">
                      {list?.value && list?.value?.length > 0 &&
                        <Pagination pageCount={listObj.pageCount} setPageLimit={setPageLimit}
                          handlePageClick={handlePageClick} page={listObj.page - 1} limit={listObj.limit} />
                      }
                    </div>
                  </div>
                </div>
              }
            </>
          </div>
        </>
        {pageLoader === false && !firstServerCall && noMessage && list?.value?.length === 0 && Helper.valueIsNotNull(c.search) && !__check(['ALL_CONTENT_COUNT_API_CALL']).status &&
          <>
            <br />
            <div className='container'>
              <NoResultContent message={'<i class="fa fa-info-circle text-black me-1" aria-hidden="true"></i> <b> We couldn’t find any products for "' + c.search + '"</b> Please visit <span><a href="' + System.redirectToNewark(c.search) + '" className="text-blue2"><u>Newark site</u></a> </span>, an Avnet company.'} />
            </div>
          </>
        }
      </div>
    </>
  );
};

export default Listing;